<div *transloco="let t" class="flex w-full items-center justify-around">
    <div class="img-quick-purchase">
        <img [src]="data.image" />
    </div>
    <!-- <k-button check-cookies-expired outline="true" roundedIcon="true" class="" [isDisabled]="quantity===0"
        (click)="quantity > 0 ? changeQuantity(-1) : null ">
        <fa-icon [icon]="'minus'"></fa-icon>
    </k-button> -->
    <k-button check-cookies-expired class="" [isDisabled]="quantity===0"
        (click)="quantity > 0 ? changeQuantity(-1) : null " size="xs" buttonStyle="roundedIcon" [faIcon]="['fas','minus']">
    </k-button>
    <span>{{quantity}}</span>
    <!-- <k-button check-cookies-expired outline="true" roundedIcon="true" class="" (click)="changeQuantity(1) ">
        <fa-icon [icon]="'plus'"></fa-icon>
    </k-button> -->
    <k-button check-cookies-expired class="" (click)="changeQuantity(1) " size="xs" buttonStyle="roundedIcon"
        [faIcon]="['fas','plus']">
    </k-button>
    <!-- <k-button check-cookies-expired (click)="buy()" [isDisabled]="quantity < 1" class="" height="35px">
        <span>{{t('shared.buy')}}</span>
    </k-button> -->
    <k-button check-cookies-expired (click)="buy()" [isDisabled]="quantity < 1" class="" size="xs"
        buttonStyle="gradient" [label]="t('shared.buy')">
    </k-button>
</div>